
import useUpdateQueue from "./mutation/useUpdateQueue";
import { QUERY_KEY } from "@Constants/query-keys";
import { useQueryClient } from "react-query";
import { Modal } from "antd";

const useUpdateQueues = () => {
  const queryClient = useQueryClient();
  const mutationUpdateQueue = useUpdateQueue();

  const onCheckPatient = (queueId) => {
    const payload = {
      _method: "PATCH",
      queue_status_id: 4,
    };
    mutationUpdateQueue.mutate(
      { queueId, payload },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([QUERY_KEY.GET_ALL_ACTIVE_QUEUE]);
        },
        onError: () => {
          Modal.error({
            title: "Gagal!",
            content: "Tidak Ada Antrian Selanjutnya",
          });
        },
      }
    );
  };

  const onPassesPatient = (queueId) => {
    const payload = {
      _method: "PATCH",
      queue_status_id: 6,
    };
    mutationUpdateQueue.mutate(
      { queueId, payload },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([QUERY_KEY.GET_ALL_ACTIVE_QUEUE]);
        },
        onError: () => {
          Modal.error({
            title: "Gagal!",
            content: "Tidak Ada Antrian Selanjutnya",
          });
        },
      }
    );
  };

  const onEmergencyPatient = (queueId) => {
    const payload = {
      _method: "PATCH",
      queue_status_id: 8,
    };

    mutationUpdateQueue.mutate(
      { queueId, payload },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([QUERY_KEY.GET_ALL_ACTIVE_QUEUE]);
        },
        onError: () => {
          Modal.error({
            title: "Gagal!",
            content: "Tidak Ada Antrian Selanjutnya",
          });
        },
      }
    );
  };

  return {
    isLoading: mutationUpdateQueue.isLoading,
    onCheckPatient,
    onPassesPatient,
    onEmergencyPatient,
  };
};

export default useUpdateQueues;
